import { DraftStepType } from '../../../insights.enums';
import { APP_LOOKUP_IDS } from '../print-bip/behavior-section-and-lookup-mapping.constant';
import { NativeFieldDescriptor } from './define-behavior-wizard.interface';

// Challenging Behavior category fields only — Behavior Screener, Strategy
// Details, Reports, and Questionnaires are separate template sections this
// wizard never reads. controlNames are copied verbatim from
// define-behavior.component.ts's pageTitles (lines 204-276) so the emitted
// form payload stays identical to the existing fixed wizard.
export const NATIVE_FIELD_DESCRIPTORS: Record<number, NativeFieldDescriptor> = {
  [APP_LOOKUP_IDS.CaseBehaviorTypes]: {
    lookupId: APP_LOOKUP_IDS.CaseBehaviorTypes,
    label: 'Behavior Types',
    controlNames: ['caseBehaviorTypeIds', 'caseBehaviorTypeDescriptions'],
  },
  [APP_LOOKUP_IDS.OperationalDefinition]: {
    lookupId: APP_LOOKUP_IDS.OperationalDefinition,
    label: 'Operational Definition',
    controlNames: ['operationalDefinition'],
  },
  [APP_LOOKUP_IDS.Frequency]: {
    lookupId: APP_LOOKUP_IDS.Frequency,
    label: 'Frequency',
    controlNames: [
      'behaviourFrequencyId',
      'behaviourFrequencyCount',
      'isDurationRequired',
      'duration',
    ],
  },
  [APP_LOOKUP_IDS.Intensity]: {
    lookupId: APP_LOOKUP_IDS.Intensity,
    label: 'Intensity',
    controlNames: ['behaviourIntensityId'],
  },
  [APP_LOOKUP_IDS.Environmnets]: {
    lookupId: APP_LOOKUP_IDS.Environmnets,
    label: 'Environments',
    controlNames: ['caseBehaviorEnvironmentIds'],
  },
  [APP_LOOKUP_IDS.SettingEvents]: {
    lookupId: APP_LOOKUP_IDS.SettingEvents,
    label: 'Setting Events',
    controlNames: ['caseBehaviorSettingEventIds'],
  },
  [APP_LOOKUP_IDS.Antecedents]: {
    lookupId: APP_LOOKUP_IDS.Antecedents,
    label: 'Antecedents',
    controlNames: [
      'caseBehaviorAntecedentIds',
      'caseBehaviorAntecedentDescription',
    ],
  },
  [APP_LOOKUP_IDS.Consequences]: {
    lookupId: APP_LOOKUP_IDS.Consequences,
    label: 'Consequences',
    controlNames: [
      'caseBehaviorConsequenceIds',
      'caseBehaviorConsequenceDescription',
    ],
  },
  [APP_LOOKUP_IDS.Goals]: {
    lookupId: APP_LOOKUP_IDS.Goals,
    label: 'Goals',
    controlNames: ['goals'],
  },
};

export const CANONICAL_NATIVE_ORDER: number[] = [
  APP_LOOKUP_IDS.CaseBehaviorTypes,
  APP_LOOKUP_IDS.OperationalDefinition,
  APP_LOOKUP_IDS.Frequency,
  APP_LOOKUP_IDS.Intensity,
  APP_LOOKUP_IDS.Environmnets,
  APP_LOOKUP_IDS.SettingEvents,
  APP_LOOKUP_IDS.Antecedents,
  APP_LOOKUP_IDS.Consequences,
  APP_LOOKUP_IDS.Goals,
];

export type LegacyPageRef = {
  draftStepType: DraftStepType;
  refId: number;
} | null;

// Maps the OLD hardcoded wizard's 1-based page index (define-behavior.component.ts's
// pageTitles) onto the new (draftStepType, refId) scheme, so drafts saved before this
// wizard existed still resume at the right item. Page 12 (Preview) has no single
// item to resolve to — the resume logic special-cases it to the last step.
export const LEGACY_PAGE_TO_REF: Record<number, LegacyPageRef> = {
  // refId: 1 matches buildCategoryStep()'s sentinel (backend requires
  // DraftStep > 0, so 0 can't be used here).
  1: { draftStepType: DraftStepType.ApplicationObject, refId: 1 },
  2: {
    draftStepType: DraftStepType.ApplicationObject,
    refId: APP_LOOKUP_IDS.CaseBehaviorTypes,
  },
  3: {
    draftStepType: DraftStepType.ApplicationObject,
    refId: APP_LOOKUP_IDS.OperationalDefinition,
  },
  4: {
    draftStepType: DraftStepType.ApplicationObject,
    refId: APP_LOOKUP_IDS.Frequency,
  },
  5: {
    draftStepType: DraftStepType.ApplicationObject,
    refId: APP_LOOKUP_IDS.Intensity,
  },
  6: {
    draftStepType: DraftStepType.ApplicationObject,
    refId: APP_LOOKUP_IDS.Environmnets,
  },
  7: {
    draftStepType: DraftStepType.ApplicationObject,
    refId: APP_LOOKUP_IDS.SettingEvents,
  },
  8: {
    draftStepType: DraftStepType.ApplicationObject,
    refId: APP_LOOKUP_IDS.Antecedents,
  },
  9: {
    draftStepType: DraftStepType.ApplicationObject,
    refId: APP_LOOKUP_IDS.Consequences,
  },
  10: {
    draftStepType: DraftStepType.ApplicationObject,
    refId: APP_LOOKUP_IDS.Goals,
  },
  11: { draftStepType: DraftStepType.Question, refId: 0 },
  12: null,
};
